// lib/store.ts
import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { createWrapper } from 'next-redux-wrapper'
import settingreducer from '@/lib/features/settingSlice'
import wishlistreducer from '@/lib/features/wishlistSlice'
import cartreducer from '@/lib/features/cartSlice'
import userreducer from '@/lib/features/userSlice'
import compareProductReducer from '@/lib/features/compareProductsSlice'
import recentViewProductReducer from '@/lib/features/recentViewProducts'
import ringBuilderReducer from '@/lib/features/ringBuilderSlice'
import diamondCountReducer from '@/lib/features/diamondCountSlice'

const rootReducer = combineReducers({
  settings: settingreducer,
  wishlist: wishlistreducer,
  cart: cartreducer,
  user: userreducer,
  compareProducts: compareProductReducer,
  recentViewProducts: recentViewProductReducer,
  ringBuilder: ringBuilderReducer,
  diamondCount: diamondCountReducer
})

export const makeStore = (preloadedState?: any) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    devTools: process.env.NODE_ENV !== 'production'
  })
}

export type AppStore = ReturnType<typeof makeStore>
export type AppState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']
